<template>
<!-- 用户管理 -->
    <div class="main_container">
        <!-- 查询部分 -->
       <div class="condition_box clearfix">
        <el-form :inline="true" :model="filters">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <!-- <el-form :inline="true" :model="filters"> -->
                    <el-form-item>
                        <span  class="inp_title">申请人电话:</span>
                    </el-form-item>
                    <el-form-item class="form_item">
                       <el-input  class="inp_item" placeholder="电话" v-model="paramsdata.phoneNum"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="chaxun_btn" @click="searchFn">查询</el-button>
                    </el-form-item>
                <!-- </el-form> -->
            </el-col>
           </el-form>
       </div>
       <!-- 内容部分 -->
       <div class="table_box">
            <my-table :items="tableData" :headers="tableHeader" :oprateOption="oprateOption"  :totalNum="TotalNum" :pageSize="paramsdata.pageSize" @getTableData="getTableData" :listLoading="listLoading" :oprateItems="oprateBtns" @viewFn="viewFn" @editFn="editFn">
                <template slot-scope='{props}' slot="caozuo">
                    <span class="stopBtn"   @click="changeStatus(props.row.ID,props.row.Status)" >
                    {{props.row.caozuoText}}
                    </span>
                </template>
            </my-table>
        </div>

    </div>
</template>
<script>
import MyTable from '@/components/Table'

export default {
    components: {
        MyTable
    },
    data(){
        return{
            input2:"",
            input21:"",
            filters:{},
            tableData3: [],
            border:true,
            currentPage1: 5,
            listLoading: true,
            tableHeader: [
                // {prop: 'PersonName', label: '商家姓名',width: 200},
                {prop: 'PhoneNum', label: '申请人电话'},
                {prop: 'StatusText', label: '状态'},
                {prop: 'caozuo', label: '操作',show: 'template'},
            ],
            oprateBtns: [
                {text: '启用', method: 'viewFn',class: 'view_btn', key: 'qy'},
                {text: '禁用', method: 'editFn', key: 'jy'},
            ],
            tableData: [
            ],
            oprateOption:{
                hasOprate:false,
                oprateName:"操作",
                width:""
            },
            TotalNum: 1,
            statusMap: {
                1: '已启用',
                0: '已禁用'
            },
            paramsdata : {
                phoneNum: "",
                pageIndex:1,//第几页
                pageSize:20//每页多少条
            },
        }
    },
    methods:{
        handleClick(row){
            // this.$router.push('/applyIndex/viewCancel');
            console.log("row---",row.id);
            this.$router.push({
                path:"/viewInfo",
                name:'撤除申请详情',
                params:{
                    id:row.id
                }
            });
        },

        changeStatus(UserID,Status){
            var dataParams = {
                UserID:''+UserID,
                Status:""
            }
            if(Status==1||Status==2){
                dataParams.Status =0
            }else if(Status==0){
                dataParams.Status =1
            }

            this.$api.mangUserChangeStatus(dataParams).then(res =>{
                console.log(res)
                if(res.data.result){
                    this.getTableData();
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })

        },
        viewFn (d){
        console.log('view------',d);
        },
        editFn (d){
        console.log('edit------',d);
        },
        getTableData(p){
        var _this = this;
        _this.listLoading = true;
        if (!p){
            p = 1;
        }
        console.log('getdata', p)
        if (!!p) {
            this.paramsdata.pageIndex=p;
        }
        _this.$api.mangUserGetBysearchParam(this.paramsdata).then(res=>{
            console.log("res====",res.data.SearchList);
            if(res.data&&res.data.result){
            var tableData = res.data.info.SearchList || [];
            _this.TotalNum = res.data.info.TotalNum;
            tableData.forEach((item) => {

                if(item.Status==0){
                item.StatusText="已禁用"
                item.caozuoText="启用"
                }else if(item.Status==1){
                item.StatusText="已启用"
                item.caozuoText="禁用"
                }else if(item.Status=2){
                item.StatusText="已验证"
                item.caozuoText="禁用"
                }
            })
            _this.tableData=tableData;
            _this.listLoading = false;
            }else{
            this.$message({
                message: res.data.message,
                type: 'error',
                duration: 5 * 1000
            })
            }

            })
        },
        searchFn(){
            this.getTableData();
        }

    },
    created(){
        this.getTableData();
    }

}
</script>
<style>

 .el-input__inner{
         height: 34px;
     }
</style>

<style <style lang="scss" scoped>

     .toolbar{
        background: transparent;
        padding: 0;
        margin: 0px;
     }
     .inp_title{
        display:inline-block;
        width:112px;
        text-align: right;
     }
    .chaxun_btn{
        height:34px;
        margin-left:100px;
        line-height:10px;
    }
    .table_box{
        margin-top:50px;
    }
    .page_box{
        margin-top:10px;
    }
</style>




// WEBPACK FOOTER //
// manageUser.vue?5aed660a